var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"panel3"},[_c('div',{staticStyle:{"min-height":"296px"},attrs:{"id":'charts' + _vm.Id}},[_c('div',[_vm._v("没有指定时间列")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }